export default class User {
    constructor({
        username = "",
        password = "",
        firstName = "",
        fatherName = "",
        lastName = "",
        phoneNumber = "",
        governorate = "",
        city = "",
        sector = "",
        roleId = 0,
        userType = 1,
        initialPassword = "",
        token = "",
        refreshToken = "",
        mustChangePassword = true,
    } = {}) {
        this.username = username;
        this.password = password;
        this.firstName = firstName;
        this.fatherName = fatherName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.governorate = governorate;
        this.city = city;
        this.sector = sector;
        this.roleId = roleId;
        this.userType = userType;
        this.initialPassword = initialPassword;
        this.mustChangePassword = mustChangePassword;
        this.token = token;
        this.refreshToken = refreshToken;

    }

    // 🟢 تحويل بيانات الاستجابة إلى كائن User
    static fromLoginApi(data = {}) {
        return new User({
            token: data.token,
            refreshToken: data.refreshToken,
            mustChangePassword: data.mustChangePassword,
            username: data.user.username,
            firstName: data.user.firstName,
            lastName: data.user.lastName,
            governorate: data.user.governorate,
            city: data.user.city,
            sector: data.user.sector,
        });
    }

    // ارسال بيانات تسجيل الدخول
    toLoginApi() {
        return {
            username: this.username,
            password: this.password,
        };
    }

    // بيانات إنشاء حساب
    userToCreateAccountAPI() {
        return {
            username: this.username,
            firstName: this.firstName,
            fatherName: this.fatherName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            governorate: this.governorate,
            city: this.city,
            sector: this.sector,
            roleId: this.roleId,
            userType: this.userType,
            initialPassword: this.initialPassword,
            mustChangePassword: this.mustChangePassword,
        };
    }


    userToEditAPI() {
        return {
            firstName: this.firstName,
            fatherName: this.fatherName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            governorate: this.governorate,
            city: this.city,
            sector: this.sector,
            roleId: this.roleId,
        };
    }

}
